import {Button, Checkbox, FormControlLabel, Stack, Typography} from '@mui/material';
import {translations} from 'presentation/translations-new';
import React from 'react';
import {formatText} from 'presentation/utils';
import {openGoogleMaps} from 'presentation/pages/private/authorizations/utils/openGoogleMaps';
import {formatProviderAddress} from 'presentation/pages/private/authorizations/utils/formatProviderAddress';
import {StyledBox} from './styles';
import {ProviderAddressProps} from './types';

const {seeMap} = translations['pt-br'].commons;

export const ProviderCheckbox = ({
	provider,
	selected,
	onChange,
	dataTagId,
}: ProviderAddressProps) => (
	<StyledBox data-tag-id={dataTagId}>
		<FormControlLabel
			sx={{
				display: 'flex',
				alignItems: 'flex-start',
			}}
			control={
				<Checkbox checked={selected} onChange={() => onChange(provider)} sx={{pt: 0}} />
			}
			label={
				<Stack pl={1} gap={1}>
					<Typography fontWeight="600">{formatText(provider?.nmPrestador)}</Typography>
					<span>
						<Typography variant="body2">{formatProviderAddress(provider)}</Typography>
						<Button
							variant="text"
							color="primary"
							sx={{
								cursor: 'pointer',
								padding: 0,
								fontWeight: 400,
								lineHeight: '150%',
							}}
							onClick={() => openGoogleMaps(provider)}>
							{seeMap}
						</Button>
					</span>
				</Stack>
			}
		/>
	</StyledBox>
);
